<template>
    <div class="DashboardLanguageRepetitionNotification" @click="gotoMemolanguage()">
        <div class="icon" :style="{ backgroundImage: `url(${image})` }" />
        <div>
            <div class="text">
                {{ $tc('text', dueRepetitionCount, { count: dueRepetitionCount }) }}
                <span class="language">
                    {{ $t(`memolanguage.languageLabels.${languageId}`) }}
                </span>
            </div>
        </div>
    </div>
</template>

<translations>
  text: 'You have {count} repetition in | You have {count} repetitions in'
  text_no: 'Du har {count} repetisjon i | Du har {count} repetisjoner i'
</translations>

<script>
const images = require.context('@/assets/images/flags/', true, /\.(png)$/);

export default {
    props: {
        dueRepetitionCount: {
            type: Number,
            required: true
        },
        languageId: {
            type: String,
            required: true
        }
    },
    computed: {
        image() {
            try {
                return images(`./${this.languageId}.png`);
            } catch (err) {
                return null;
            }
        }
    },
    methods: {
        gotoMemolanguage() {
            this.$emit('action');
            this.$router.push(`/memolanguage/${this.languageId}/home`);
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardLanguageRepetitionNotification {
    padding: 1em;
    line-height: 1.5em;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.icon {
    $size: 2.5em;
    width: $size;
    height: $size;
    border-radius: 50%;
    margin-right: 1em;

    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}
.text {
    color: rgba(black, 0.5);
}
.time {
    color: rgba(black, 0.5);
    margin-top: 0.5em;
}
.language {
    // display: inline-flex;
    // align-items: center;
    // color: rgba(black, 0.9);
}
.flag {
    $size: 1.2em;
    display: inline-block;
    width: $size;
    height: $size;

    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 0.3em;
}
</style>
